import { IContractCustomSection } from 'services/contract/types';
import './ContractSection.scss';

interface ContractSectionProps {
  section: IContractCustomSection;
  level?: number;
}

export const ContractSection = ({ section, level = 0 }: ContractSectionProps) => {
  const agreements = section.agreement ?? [];
  const nestedSections = section.customSections ?? [];

  return (
    <div className="contract-section" data-level={level}>
      <div className="contract-section__header">
        <span className="contract-section__title">{section.title}</span>
      </div>

      <div className="contract-section__content">
        <div className="contract-section__content-inner">
          {agreements
            .slice()
            .sort((a, b) => a.position - b.position)
            .map((agreement) => (
              <div
                key={`${agreement.position}-${agreement.title}`}
                className="contract-section__row"
              >
                <span className="contract-section__text">{agreement.title}</span>
                <span className="contract-section__value">{agreement.value}</span>
              </div>
            ))}

          {nestedSections.length > 0 && (
            <div className="contract-section__nested">
              {nestedSections
                .slice()
                .sort((a, b) => a.position - b.position)
                .map((nestedSection) => (
                  <ContractSection
                    key={`${nestedSection.position}-${nestedSection.title}`}
                    section={nestedSection}
                    level={level + 1}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
